export default "__VITE_ASSET__BX436cLO__";